import template from "./OrderConfirmStepComponent.html";
import {OrderConfirmComponentController} from "../OrderConfirmController";
import {ITimeoutService} from "angular";
import {OptionsTicket, OptionsWizardOrder} from "../../../../types/OptionsTicket";
import {OrderVettingService} from "../../../../services/OrderVettingService";
import {Premium} from "../../../../types/OrderVettingResponse";
import {CurrentUserService} from "../../../../../../../services/user/CurrentUserService";
import {MarginQuizService} from "../../../../../../../quiz/margin/service/MarginQuizService";
import {AccountStore} from "../../../../../../../account/store/AccountStore";
import {QuoteStore} from "../../../../../../../quote/store/QuoteStore";

export const OrderConfirmStep = "orderConfirmStep";

export function orderConfirmStep() {
    return {
        template,
        bindings: {
            trades: "<",
            portfolio: "<",
            form: "<"
        },
        controllerAs: "ctrl",
        controller: OrderConfirmStepComponentController
    };
}

export class OrderConfirmStepComponentController extends OrderConfirmComponentController {

    public trades: Array<OptionsWizardOrder>;

    /** @ngInject */
    public constructor($timeout: ITimeoutService,
                       currentUserService: CurrentUserService,
                       orderVettingService: OrderVettingService,
                       marginQuizService: MarginQuizService,
                       accountStore: AccountStore,
                       quoteStore: QuoteStore) {
        super($timeout, currentUserService, orderVettingService, marginQuizService, accountStore, quoteStore);
    }

    protected orderTickets(): Array<OptionsTicket> {
        return this.trades.map(tr => tr.ticket)
            .map((tr) => {
                return {
                    ...tr,
                    quantity: Math.abs(tr.quantity)
                };
            });
    }

    protected addPremiumToTrade(premium: Premium): void {
        const existingTrade = this.trades.find(tr => tr.ticket.code === premium.code);
        if (existingTrade != null) {
            existingTrade.price = premium.price;
            existingTrade.premium = premium.premium;
        }
    }
}
